

// //toast
import toast from '@/components/Toast';

const PC_BASE_WIDTH = 1920;

export function applyPcStageScale(options = {}) {
    if (typeof window === 'undefined' || typeof document === 'undefined') {
        return null;
    }

    const stageSelector = options.stage || '#pc-stage';
    const shellSelector = options.shell || '#pc-stage-shell';
    const baseWidth = typeof options.baseWidth === 'number' ? options.baseWidth : PC_BASE_WIDTH;
    const maxScale = typeof options.maxScale === 'number' ? options.maxScale : 1;
    const minScale = typeof options.minScale === 'number' ? options.minScale : 0;
    const stage = typeof stageSelector === 'string' ? document.querySelector(stageSelector) : stageSelector;
    const shell = typeof shellSelector === 'string' ? document.querySelector(shellSelector) : shellSelector;

    if (!stage || !shell) {
        return null;
    }

    const viewportWidth = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
    const scale = Math.max(minScale, Math.min(viewportWidth / baseWidth, maxScale));
    const stageHeight = stage.offsetHeight || stage.scrollHeight || 0;
    const scaledWidth = Math.round(baseWidth * scale);
    const scaledHeight = Math.round(stageHeight * scale);

    shell.style.width = '100%';
    shell.style.height = scaledHeight + 'px';
    stage.style.transform = 'scale(' + scale + ')';

    return {
        scale,
        viewportWidth,
        scaledWidth,
        scaledHeight,
        baseWidth,
        stageHeight,
    };
}

export function createPcStageScaler(options = {}) {
    if (typeof window === 'undefined' || typeof document === 'undefined') {
        return {
            mount() {},
            unmount() {},
            refresh() {
                return null;
            },
        };
    }

    const eventOptions = { passive: true };
    const onRefresh = typeof options.onRefresh === 'function' ? options.onRefresh : null;
    let rafId = null;

    const refresh = () => {
        rafId = null;
        const result = applyPcStageScale(options);
        if (result && onRefresh) {
            onRefresh(result);
        }
        return result;
    };

    const scheduleRefresh = () => {
        if (rafId) {
            cancelAnimationFrame(rafId);
        }
        rafId = requestAnimationFrame(refresh);
    };

    return {
        mount() {
            refresh();
            window.addEventListener('resize', scheduleRefresh, eventOptions);
            window.addEventListener('orientationchange', scheduleRefresh, eventOptions);
        },
        unmount() {
            if (rafId) {
                cancelAnimationFrame(rafId);
                rafId = null;
            }
            window.removeEventListener('resize', scheduleRefresh, eventOptions);
            window.removeEventListener('orientationchange', scheduleRefresh, eventOptions);
        },
        refresh,
    };
}

let utils = {
    $toast: toast, 
}

export default utils;